document.addEventListener('DOMContentLoaded', function () {
    const stars = document.querySelectorAll('.js-reviewStars i');
    const ratingInput = document.getElementById('rating');
    
    // Hover effect
    stars.forEach(star => {
        star.addEventListener('mouseenter', function () {
            const value = parseInt(this.getAttribute('data-value'));
            // Set stars to full up to the hovered star
            stars.forEach((s, index) => {
                if (index < value) {
                    s.classList.remove('bx-star');
                    s.classList.add('bxs-star');
                } else {
                    s.classList.remove('bxs-star');
                    s.classList.add('bx-star');
                }
            });
        });

        // Reset stars on mouse leave
        star.addEventListener('mouseleave', function () {
            const value = parseInt(ratingInput.value) || 0;
            stars.forEach((s, index) => {
                if (index < value) {
                    s.classList.remove('bx-star');
                    s.classList.add('bxs-star');
                } else {
                    s.classList.remove('bxs-star');
                    s.classList.add('bx-star');
                }
            });
        });

        // Click to set rating
        star.addEventListener('click', function () {
            const value = parseInt(this.getAttribute('data-value'));
            ratingInput.value = value;  // Set the hidden input's value
        });
    });

});

( function( $ ) {

    $(document).on('click', '.js-reviewsToggle', function(e) {
        e.preventDefault();
        $('.js-reviewsForm').slideToggle(300);
    });

} ) ( jQuery );